<template>
  <v-row>
    <v-col cols="12">
      <form @submit.prevent="save">
        <!-- Top-level name -->
        <v-text-field
          v-model="form.name"
          label="Ime *"
          class="mb-12"
          style="max-width: 50%;"
        />
        <FormErrors v-if="$v.form.$error && !$v.form.name.required">
          <FormErrorsLine text="Polje je obvezno" />
        </FormErrors>

        <div class="d-flex permissions_wrapper" style="gap: 25px;">
          <!-- LEFT COLUMN -->
          <div class="d-flex flex-column" style="flex: 1;gap: 25px;">
            <h2>Aplikacija</h2>
            <!-- Invoices  -->
            <SettingsGroup
              title="Računi"
              category="invoices"
              :relevance="2"
              :settings="filteredSettings('invoices', 2)"
              :special="[
                { key: 'repeat_print_permission', model: form, field: 'repeat_print_permission', label: 'Ponovno tiskanje' },
                { key: 'negative_amount_permission', model: form, field: 'negative_amount_permission', label: 'Storno račun' },
                { key: 'discount_permission', model: form, field: 'discount_permission', label: 'Dodajanje popusta' }
              ]"
              :orderMap="{
                repeat_print_permission: 1,
                negative_amount_permission: 2,
                permission_allow_deleting_saved_articles: 3,
                permission_allow_negative_articles: 4,
                permission_payment_type_with_discount: 5,
                permission_revert_invoice_timeout: 6,
                permission_setting_own_invoices: 7,
                permission_num_last_invoices: 8,
                permission_ellypos_application_integration: 9,
                discount_permission: 10
              }"
              :appropriateName="appropriateName"
            />

            <!-- Reports -->
            <SettingsGroup
              title="Izpisi"
              category="reports"
              :relevance="2"
              :settings="filteredSettings('reports', 2)"
              :master="{ key: 'sales_log_permission', model: form, field: 'sales_log_permission', label: 'Izpisi' }"
              :appropriateName="appropriateName"
            />

            <!-- Tables -->
            <SettingsGroup
              title="Mize"
              category="table"
              :relevance="2"
              :settings="filteredSettings('table', 2)"
              :special="[
                { key: 'clear_table_permission', model: form, field: 'clear_table_permission', label: 'Brisanje mize' },
              ]"
              :appropriateName="appropriateName"
            />

            <!-- Settings -->
            <SettingsGroup
              title="Nastavitve"
              category="settings"
              :relevance="2"
              :disabledCondition="!globalSettingsForm['permission_setting_enabled'].enabled"
              :settings="filteredSettings('settings', 2)"
              :master="{ key: 'permission_setting_enabled', model: globalSettingsForm['permission_setting_enabled'], label: 'Nastavitve' }"
              :appropriateName="appropriateName"
            />

            <SettingsGroup
              title="Spletna pisarna"
              category="cms_app"
              :relevance="2"
              :settings="filteredSettings('cms_app', 2)"
              :appropriateName="appropriateName"
            />
          </div>

          <!-- RIGHT COLUMN -->
          <div class="d-flex flex-column" style="flex: 1;gap: 25px;">
            <h2>Spletna pisarna</h2>

            <SettingsGroup
              title="Menu"
              category="cms_menu"
              :relevance="1"
              :settings="filteredSettings('cms_menu', 1)"
              :appropriateName="appropriateName"
            />

            <SettingsGroup
              title="Računi"
              category="invoice_cms"
              :relevance="1"
              :disabledCondition="!globalSettingsForm['permission_cms_invoice_history'].enabled"
              :settings="filteredSettings('invoice_cms', 1)"
              :master="{ key: 'permission_cms_invoice_history', model: globalSettingsForm['permission_cms_invoice_history'], label: 'Zadnji računi' }"
              :appropriateName="appropriateName"
            />

            <SettingsGroup
              title="Izpisi"
              category="reports_cms"
              :relevance="1"
              :disabledCondition="!globalSettingsForm['permission_cms_logs'].enabled"
              :settings="filteredSettings('reports_cms', 1)"
              :master="{ key: 'permission_cms_logs', model: globalSettingsForm['permission_cms_logs'], label: 'Izpisi' }"
              :appropriateName="appropriateName"
            />

            <SettingsGroup
              title="Ostali šifranti"
              category="other_enums_cms"
              :relevance="1"
              :disabledCondition="!globalSettingsForm['permission_cms_other_enums'].enabled"
              :settings="filteredSettings('other_enums_cms', 1)"
              :master="{ key: 'permission_cms_other_enums', model: globalSettingsForm['permission_cms_other_enums'], label: 'Ostali šifranti' }"
              :appropriateName="appropriateName"
            />

            <SettingsGroup
              title="Materialno poslovanje"
              category="material_management_cms"
              :relevance="1"
              :disabledCondition="!globalSettingsForm['permission_cms_material_management'].enabled"
              :settings="filteredSettings('material_management_cms', 1)"
              :master="{ key: 'permission_cms_material_management', model: globalSettingsForm['permission_cms_material_management'], label: 'Materialno poslovanje' }"
              :appropriateName="appropriateName"
            />
          </div>
        </div>

        <!-- Buttons -->
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">
          Prekliči
        </v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import SettingsGroup from './SettingGroup.vue'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    SettingsGroup
  },
  props: {
    userType: {
      default: () => {},
      type: Object
    },
    new: {
      default: false,
      type: Boolean,
    }
  },
  computed: {
    /* globalSettings () {
      return this.$store.state.settings.globalSettings.map(setting => ({
        ...setting,
        category: Object.keys(this.categories).find((catKey) => {
          if (this.categories[catKey].some(val => val === setting.key)) {
            return catKey
          }
        }),
        order: this.sortOrders[setting.key] || 1,
      }))
    } */
  },
  data () {
    return {
      categories: {
        invoices: ['permission_num_last_invoices','permission_revert_invoice_timeout','permission_allow_negative_articles','permission_allow_deleting_saved_articles','permission_payment_type_with_discount','permission_ellypos_application_integration','permission_setting_own_invoices'],
        reports: ['permission_canceled_tables_log','permission_currentstock_log','permission_sales_articles_log','permission_sales_log','permission_salesman_sales_log'],
        table: ['permission_print_table','permission_allow_ordering','permission_transfer_table','permission_create_temporary_table','permission_end_active_tables_before_shift_start','permission_setting_see_own_open_tables'],
        settings: ['permission_modify_application_look','permission_setting_invoices','permission_setting_skip_fiscalization','permission_setting_tables','permission_setting_ordering','permission_setting_other'],
        cms_menu: ['permission_cms_home', 'permission_cms_ordering_history', 'permission_cms_articles', 'permission_cms_users', 'permission_cms_clients'],
        invoice_cms: ['permission_cms_invoice_history_update','permission_cms_invoice_history_revert','permission_cms_invoice_history_print_or_copy'],
        cms_app: ['permission_setting_cms_enabled'],
        /* ordering_cms: ['permission_cms_ordering_history'], */
        reports_cms: ['permission_cms_sales_log','permission_cms_salesman_log','permission_cms_articles_log', 'permission_allow_print_invoices_report', 'permission_cms_worktime_log','permission_cms_controltape_log'],
        /* articles_cms: ['permission_cms_articles'], */
        /* users_cms: ['permission_cms_users'], */
        /* clients_cms: ['permission_cms_clients'], */
        other_enums_cms: [
          'permission_cms_other_enums_groups',
          'permission_cms_other_enums_levels',
          'permission_cms_other_enums_places',
          'permission_cms_other_enums_tables',
          'permission_cms_other_enums_print_locations',
          'permission_cms_other_enums_groups_main',
          'permission_cms_other_enums_user_permissions',
          'permission_cms_other_enums_payment_types',
          'permission_cms_other_enums_comments',
          'permission_cms_other_enums_price_levels'
        ],
        material_management_cms: [
          'permission_cms_material_management_current_stock',
          'permission_cms_material_management_acceptance_form',
          'permission_cms_material_management_writeoff_forms',
          'permission_cms_material_management_inventory_forms',
          'permission_cms_material_management_analytics_forms'
        ]
        // test_app: ['permission_test_false', 'permission_test_true', 'permission_test2_false', 'permission_test2_true']
      },
      sortOrders: {
        repeat_print_permission: 1,
        negative_amount_permission: 2,
        permission_allow_negative_articles: 3,
        permission_allow_deleting_saved_articles: 4,
        permission_payment_type_with_discount: 5,
        permission_sales_log: 6,
        permission_salesman_sales_log: 7,
        permission_sales_articles_log: 8,
        permission_revert_invoice_timeout: 9,
        permission_currentstock_log: 10,
        permission_canceled_tables_log: 11,
        permission_num_last_invoices: 15,
        permission_print_table: 1,
        permission_allow_ordering: 2,
        permission_transfer_table: 3,
        permission_create_temporary_table: 4,
        permission_end_active_tables_before_shift_start: 5,
        permission_setting_see_own_open_tables: 6,
        permission_modify_application_look: 1,
        permission_setting_invoices: 2,
        permission_setting_skip_fiscalization: 3,
        permission_setting_tables: 4,
        permission_setting_ordering: 5,
        permission_setting_other: 6,
        permission_setting_own_invoices: 7,
        permission_ellypos_application_integration: 11,

        permission_cms_home: 1,
        permission_cms_invoice_history: 1,
        permission_cms_invoice_history_update: 2,
        permission_cms_invoice_history_revert: 3,
        permission_cms_invoice_history_print_or_copy: 4,
        permission_cms_ordering_history: 1,
        permission_cms_logs: 1,
        permission_cms_sales_log: 2,
        permission_cms_salesman_log: 3,
        permission_cms_articles_log: 4,
        permission_allow_print_invoices_report: 5,
        permission_cms_worktime_log: 6,
        permission_cms_controltape_log: 7,
        permission_cms_articles: 1,
        permission_cms_users: 1,
        permission_cms_clients: 1,
        permission_cms_other_enums: 1,
        permission_cms_other_enums_groups: 2,
        permission_cms_other_enums_levels: 3,
        permission_cms_other_enums_places: 4,
        permission_cms_other_enums_tables: 5,
        permission_cms_other_enums_print_locations: 6,
        permission_cms_other_enums_groups_main: 7,
        permission_cms_other_enums_user_permissions: 8,
        permission_cms_other_enums_payment_types: 9,
        permission_cms_other_enums_comments: 10,
        permission_cms_other_enums_price_levels: 11,
        permission_cms_material_management: 1,
        permission_cms_material_management_current_stock: 2,
        permission_cms_material_management_acceptance_form: 3,
        permission_cms_material_management_writeoff_forms: 4,
        permission_cms_material_management_inventory_forms: 5,
        permission_cms_material_management_analytics_forms: 6,
      },
      form: {
        name: null,
        repeat_print_permission: false,
        delete_permission: false,
        discount_permission: false,
        sales_log_permission: false,
        negative_amount_permission: false,
        clear_table_permission : false
      },
      globalSettingsForm: {
        permission_canceled_tables_log: { value: false, enabled: false, isCheckbox: true },
        permission_allow_deleting_saved_articles: { value: false, enabled: false, isCheckbox: true },
        permission_payment_type_with_discount: { value: false, enabled: false, isCheckbox: true },
        permission_allow_negative_articles: { value: false, enabled: false, isCheckbox: true },
        permission_currentstock_log: { value: false, enabled: false, isCheckbox: true },
        permission_num_last_invoices: { value: '0', enabled: false, isCheckbox: false },
        permission_print_table: { value: false, enabled: false, isCheckbox: true },
        permission_allow_ordering: { value: false, enabled: false, isCheckbox: true },
        permission_transfer_table: { value: false, enabled: false, isCheckbox: true },
        permission_create_temporary_table: { value: false, enabled: false, isCheckbox: true },
        permission_end_active_tables_before_shift_start: { value: false, enabled: false, isCheckbox: true },
        permission_setting_see_own_open_tables: { value: false, enabled: false, isCheckbox: true },
        permission_revert_invoice_timeout: { value: '0', enabled: false, isCheckbox: false },
        permission_sales_articles_log: { value: false, enabled: false, isCheckbox: true },
        permission_sales_log: { value: false, enabled: false, isCheckbox: true },
        permission_salesman_sales_log: { value: false, enabled: false, isCheckbox: true },
        permission_ellypos_application_integration: { value: false, enabled: false, isCheckbox: true },
        permission_modify_application_look: { value: false, enabled: false, isCheckbox: true },
        permission_setting_invoices: { value: false, enabled: false, isCheckbox: true },
        permission_setting_skip_fiscalization: { value: false, enabled: false, isCheckbox: true, tabbed: true },
        permission_setting_tables: { value: false, enabled: false, isCheckbox: true },
        permission_setting_ordering: { value: false, enabled: false, isCheckbox: true },
        permission_setting_enabled: { value: false, enabled: false, isCheckbox: true },
        permission_setting_cms_enabled: { value: false, enabled: false, isCheckbox: true },
        permission_setting_other: { value: false, enabled: false, isCheckbox: true },
        permission_setting_own_invoices: { value: false, enabled: false, isCheckbox: true },
        permission_cms_home: { value: false, enabled: false, isCheckbox: true },
        permission_cms_invoice_history: { value: false, enabled: false, isCheckbox: true },
        permission_cms_invoice_history_update: { value: false, enabled: false, isCheckbox: true },
        permission_cms_invoice_history_revert: { value: false, enabled: false, isCheckbox: true },
        permission_cms_invoice_history_print_or_copy: { value: false, enabled: false, isCheckbox: true },
        permission_cms_ordering_history: { value: false, enabled: false, isCheckbox: true },
        permission_cms_logs: { value: false, enabled: false, isCheckbox: true },
        permission_cms_sales_log: { value: false, enabled: false, isCheckbox: true },
        permission_cms_salesman_log: { value: false, enabled: false, isCheckbox: true },
        permission_cms_articles_log: { value: false, enabled: false, isCheckbox: true },
        permission_allow_print_invoices_report: { value: false, enabled: false, isCheckbox: true },
        permission_cms_worktime_log: { value: false, enabled: false, isCheckbox: true },
        permission_cms_controltape_log: { value: false, enabled: false, isCheckbox: true },
        permission_cms_articles: { value: false, enabled: false, isCheckbox: true },
        permission_cms_users: { value: false, enabled: false, isCheckbox: true },
        permission_cms_clients: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_groups: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_levels: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_places: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_tables: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_print_locations: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_groups_main: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_user_permissions: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_payment_types: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_comments: { value: false, enabled: false, isCheckbox: true },
        permission_cms_other_enums_price_levels: { value: false, enabled: false, isCheckbox: true },
        permission_cms_material_management: { value: false, enabled: false, isCheckbox: true },
        permission_cms_material_management_current_stock: { value: false, enabled: false, isCheckbox: true },
        permission_cms_material_management_acceptance_form: { value: false, enabled: false, isCheckbox: true },
        permission_cms_material_management_writeoff_forms: { value: false, enabled: false, isCheckbox: true },
        permission_cms_material_management_inventory_forms: { value: false, enabled: false, isCheckbox: true },
        permission_cms_material_management_analytics_forms: { value: false, enabled: false, isCheckbox: true },
        /* permission_test_false: { value: false, enabled: false, isCheckbox: true },
        permission_test_true: { value: false, enabled: false, isCheckbox: true },
        permission_test2_false: { value: false, enabled: false, isCheckbox: true },
        permission_test2_true: { value: false, enabled: false, isCheckbox: true } */
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  methods: {
    ...mapActions('settings', ['loadGlobalSettings']),
    filteredSettings(category, relevance = 2) {
      const keys = this.categories[category] || [];

      return keys
        .map(key => {
          const ref = this.globalSettingsForm[key];
          if (!ref) return null;

          // attach metadata *on the same object* (does mutate globalSettingsForm entries)
          // this keeps the object reference intact for two-way updates
          ref.key = key;
          ref.order = this.sortOrders[key] || 1;
          ref.relevance = ref.relevance || relevance;

          return ref;
        })
        .filter(setting => setting && setting.relevance === relevance)
        .sort((a, b) => a.order - b.order);
    },
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        const enabledGlobals = Object.keys(this.globalSettingsForm)
          .map(k => {
            const s = this.globalSettingsForm[k];
            return {
              key: k,
              value: s.isCheckbox ? String(s.enabled) : s.value
            };
          })
          .filter(setting => {
            const base = this.globalSettingsForm[setting.key];
            // keep only enabled
            return base.enabled && setting.value !== '0' && setting.value !== 0;
          });

        const payload = {
          ...this.form,   // includes name + top-level booleans
          settings: enabledGlobals
        };
        /* console.log('ddd: ', payload); */
        this.$emit('save', { data: { ...this.form, settings: enabledGlobals }})
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    appropriateName (key) {
      switch(key) {
        case 'permission_canceled_tables_log':
          return 'Preklicane mize'
        case 'permission_currentstock_log':
          return 'Trenutna zaloga'
        case 'permission_num_last_invoices':
          return 'Št. zadnjih računov'
        case 'permission_revert_invoice_timeout':
          return 'Čas storniranja računa'
        case 'permission_print_table':
          return 'Tiskaj mizo'
        case 'permission_allow_ordering':
          return 'Naročila'
        case 'permission_transfer_table':
          return 'Prenašanje miz'
        case 'permission_create_temporary_table':
          return 'Nova začasna miza'
        case 'permission_end_active_tables_before_shift_start':
          return 'Pred zaključkom izmene zaključi vse mize'
        case 'permission_setting_see_own_open_tables':
          return 'Ne prikazuj miz ostalih uporabnikov'
        case 'permission_setting_enabled':
          return 'Nastavitve'
        case 'permission_ellypos_application_integration':
          return 'Integracija plačil'
        case 'permission_allow_deleting_saved_articles':
          return 'Brisanje shranjenih artiklov'
        case 'permission_allow_negative_articles':
          return 'Vnos negativne količine artiklov'
        case 'permission_modify_application_look':
          return 'Izgled'
        case 'permission_setting_invoices':
          return 'Računi'
        case 'permission_setting_skip_fiscalization':
          return 'Preskoči fiskalizacijo'
        case 'permission_payment_type_with_discount':
          return 'Plačilno sredstvo s popustom'
        case 'permission_setting_tables':
          return 'Mize'
        case 'permission_setting_ordering':
          return 'Naročila'
        case 'permission_setting_other':
          return 'Ostalo'
        case 'permission_setting_own_invoices':
          return 'Samo računi uporabnika'
        case 'permission_sales_articles_log':
          return 'Promet po artiklih'
        case 'permission_setting_cms_enabled':
          return 'Spletna pisarna'
        case 'permission_sales_log':
          return 'Dnevnik prodaje'
        case 'permission_salesman_sales_log':
          return 'Promet prodajalca'
        case 'permission_cms_invoice_history':
          return 'Zadnji računi'
        case 'permission_allow_print_invoices_report':
          return 'Izpis računov'
        case 'permission_cms_invoice_history_update':
          return 'Spremeni'
        case 'permission_cms_invoice_history_revert':
          return 'Storno'
        case 'permission_cms_invoice_history_print_or_copy':
          return 'Tiskaj A4/PDF / kopija računa'
        case 'permission_cms_logs':
          return 'Izpisi'
        case 'permission_cms_sales_log':
          return 'Dnevnik prodaje'
        case 'permission_cms_salesman_log':
          return 'Promet prodajalca'
        case 'permission_cms_articles_log':
          return 'Promet po artiklih'
        case 'permission_cms_worktime_log':
          return 'Delovni čas'
        case 'permission_cms_controltape_log':
          return 'Kontrolni trak'
        case 'permission_cms_other_enums':
          return 'Ostali Šifranti'
        case 'permission_cms_other_enums_groups':
          return 'Skupine'
        case 'permission_cms_other_enums_levels':
          return 'Nivoji'
        case 'permission_cms_other_enums_places':
          return 'Prostori'
        case 'permission_cms_other_enums_tables':
          return 'Mize'
        case 'permission_cms_other_enums_print_locations':
          return 'Lokacije tiskalnikov'
        case 'permission_cms_other_enums_groups_main':
          return 'Grupe'
        case 'permission_cms_other_enums_user_permissions':
          return 'Pravice uporabnikov'
        case 'permission_cms_other_enums_payment_types':
          return 'Tipi plačila'
        case 'permission_cms_other_enums_comments':
          return 'Opombe'
        case 'permission_cms_other_enums_price_levels':
          return 'Nivoji cen'
        case 'permission_cms_material_management':
          return 'Materialno poslovanje'
        case 'permission_cms_material_management_current_stock':
          return 'Trenutna zaloga'
        case 'permission_cms_material_management_acceptance_form':
          return 'Prevzemnice'
        case 'permission_cms_material_management_writeoff_forms':
          return 'Odpis'
        case 'permission_cms_material_management_inventory_forms':
          return 'Inventura'
        case 'permission_cms_material_management_analytics_forms':
          return 'Analitika'
        case 'permission_cms_home':
          return 'Domov'
        case 'permission_cms_ordering_history':
          return 'Zadnja naročila'
        case 'permission_cms_articles':
          return 'Artikli'
        case 'permission_cms_users':
          return 'Uporabniki'
        case 'permission_cms_clients':
          return 'Klienti'
        /* case 'permission_test_false':
          return 'Testni permisija (default false)'
        case 'permission_test_true':
          return 'Testni permisija (default true)'
        case 'permission_test2_false':
          return 'Testni permisija (default false)'
        case 'permission_test2_true':
          return 'Testni permisija2 (default true)' */
        default:
          return 'Nevpisana vrednost'
      }
    },
  },
  async created() {
    await this.loadGlobalSettings();

    // 1️⃣ Reset all settings to default: unchecked and disabled
    Object.keys(this.globalSettingsForm).forEach(key => {
      /* this.globalSettingsForm[key].value = false;
      this.globalSettingsForm[key].enabled = false;
       */
      const setting = this.globalSettingsForm[key];
      if (setting.isCheckbox) {
        setting.value = false;
      }
      setting.enabled = false;
    });

    if (this.userType) {
      Object.keys(this.form).forEach(key => {
        if (key in this.userType) {
          this.form[key] = this.userType[key];
        }
      });

      // 3️⃣ Enable only settings that exist in userType.settings
      if (Array.isArray(this.userType.settings)) {
        this.userType.settings.forEach(setting => {
          const renderSetting = getRenderSettings(setting, this.globalSettingsForm);
          this.globalSettingsForm[renderSetting.key] = {
            ...this.globalSettingsForm[renderSetting.key],
            value: renderSetting.value,
            enabled: renderSetting.enabled,  // ✅ Only enable this key
          };
        });
      }
    }

    /* console.log("Final globalSettingsForm:", JSON.parse(JSON.stringify(this.globalSettingsForm))); */
  }
}

function getRenderSettings(setting, globalSettingsForm) {
  const base = globalSettingsForm[setting.key] || {};

  const isCheckbox = typeof base.isCheckbox !== "undefined" ? base.isCheckbox : true;
  /* const parsedValue  = isCheckbox
  ? setting.value === true || setting.value === "true"
  : (typeof setting.value !== "undefined" ? setting.value : ""); */
  let parsedValue;

  if (isCheckbox) {
    parsedValue = setting.value === true || setting.value === "true";
  } else {
    // if value is undefined/null/empty, fallback to base
    parsedValue = setting.value !== undefined && setting.value !== null && setting.value !== ""
      ? setting.value
      : base.value;
  }

  /* console.log(setting, isCheckbox, parsedValue) */
  return {
    ...base,
    key: setting.key,
    value: parsedValue ,
    enabled: isCheckbox ? parsedValue : parsedValue !== '0' && parsedValue !== 0,   // only enable because we are traversing this setting now
    isCheckbox,
    relevance: setting.relevance || base.relevance || 0
  };
}

</script>

<style scoped>
  .title-bar {
    margin: 0px 5%;
    border-bottom: 1px solid #455a6433;
  }
  .title {
    padding: 10px;
  }
  @media screen and (max-width: 600px) {
    .permissions_wrapper {
      flex-direction: column;
    }
  }
</style>